export enum EnumToast {
	ERROR = 0,
	SUCCESS,
	INFO,
}
